import { render, staticRenderFns } from "./GestionCommandeDomaine.vue?vue&type=template&id=4b064962&scoped=true"
import script from "./GestionCommandeDomaine.vue?vue&type=script&lang=js"
export * from "./GestionCommandeDomaine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b064962",
  null
  
)

export default component.exports